import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';

const PaymentGatewayFeesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const PaymentGatewayFeesList = props => (
  <List filters={<PaymentGatewayFeesFilter />} {...props} >
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="gateway" />
      <TextField source="fixAmount" />
      <TextField source="percentage" />
    </Datagrid>
</List>
);

export default PaymentGatewayFeesList
